import Vue from 'vue'
import {apiUrl, alert} from '../helper'
import $ from 'jquery'
import companyMix from './companyMix'

export default {
  mixins: [companyMix],
  data () {
      return {
        // uidUrl: null, //url中的uid参选参数值，用户id
        // share: null,  //分享位置
        // plat: null,
        // sid: null,   //短地址接口添加的，用于分享追踪
        params: {},  //查询参数
        wxcode: '',    // 微信登录返回的code信息
        tcode: '',     // id
        stype: '',     // 公告类型
        fulltitle: '', // 公告标题
        diysharedesc: '',  // 自定义分享描述
    }
  },
  methods: {
    /*
     * 微信登录
     *
     * @param {String} wxcode - 微信登录所需的code字符串
     * */
    wxlogin (wxcode) {
      let query = {'code': wxcode}
      console.log("wxlogin登陆上传的query")
      console.log(query)
      $.ajax({
        url: apiUrl('/V1.0.0/user/wxlogin'),
        method: 'post',
        dataType: 'json',
        async: false,
        data: JSON.stringify(query)
      }).done((response) => {
        if (response.status === 0) {
          console.log('微信登陆')
          console.log('window.location:' + window.location );
          console.log(window.location.hash)

          console.log('window.location.hash.split(?code=)[0]:输出hash的split')
          console.log(window.location.hash.split('?code=')[0])
          console.log('window.location.hash.split(&companycode=)[1]输出companycode的split')
          console.log(window.location.hash.split('&companycode=')[1])
          if (window.location.hash.indexOf('#!/company') >= 0) {
            window.location.href = window.location.origin + '/' +  window.location.hash.split('?code=')[0] + '?companycode=' + window.location.hash.split('&companycode=')[1];
          } else {
            let _location = window.location
            window.location.href = _location.origin + '/#!' + _location.href.split('#!')[1]
            this.showguide = true
          }
        } else {
          alert(response.description)
        }
      }).fail((response) => {
        alert('请求失败')
      })
    },

    //微信签名
    getwxsign () {
      let query = {}
      query.url = window.location.href.split('#')[0]
      console.log('微信签名query的url')
      console.log(query.url)
      $.ajax({
        url: apiUrl('/V1.0.0/user/getwxsign'),
        method: 'post',
        dataType: 'json',
        data: JSON.stringify(query)
      }).done((response) => {
        if (response.status === 0) {
          let data = response.data
          console.log(123131)
          console.log(this.currentuser)
          // 权限验证配置
          wx.config({
            debug: false,
            appId: this.$config.weixin.appid,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: [          // 需要使用的JS接口列表
              'checkJsApi',        // 判断当前客户端版本是否支持指定JS接口
              'onMenuShareAppMessage',  // 分享给朋友
              'onMenuShareTimeline'     // 分享到朋友圈
            ]
          })
          console.log('>> 微信签名 ok~')
        }
      }).fail((response) => {
        alert('请求失败')
      })
    },
    /*
     * 获取微信分享详情
     *
     * @param {String} stype - 文档类型，1：A股，2：新三板，5问题库
     * @param {String} id    - 定位到的id
     * */
    getNoticeShareDesc (stype, id) {
      console.log('>获取描述')

      let desc = ''
      if (id === '' || id === undefined) {
        desc = '你可以点击查看详情...'
        return desc
      }

      // A股、新三板
      if (stype === '1' || stype === '2' || stype === '3') {
        console.log('A股新三板')

        // 如果是标题
        let _desc = ''
        let nodeName = ''
        if (document.getElementById(id)) {
          nodeName = document.getElementById(id).nodeName  // 节点类型
          if (nodeName === 'P') {  // 标题
            // let item = document.getElementById(id)
            // let nextNode = item.nextElementSibling  // 目标元素下一个兄弟节点
            // if (nextNode.nodeName === 'P') {
            //   _desc = item.innerHTML
            // }
            // if (nextNode.nodeName === 'DIV') {
            //   let next2Node = nextNode.firstElementChild   // 目标id的下一个兄弟节点的第一个子节点
            //   if (next2Node.nodeName === 'P') {
            //     _desc = next2Node.innerHTML
            //   }
            //   if (next2Node.nodeName === 'TABLE') {
            //     _desc = item.innerHTML
            //   }
            // }
            _desc = document.getElementById(id).innerText
          }
          if (nodeName === 'DIV') {
            let div = document.getElementById(id)
            let firstNode = div.firstElementChild  // div下第一个子节点

            // 文本
            if (firstNode.nodeName === 'P') {
              _desc = firstNode.innerText
            }

            // 表格
            if (firstNode.nodeName === 'TABLE') {
              // 表格显示表格的info内容
              let idChildNode = document.getElementById(id).childNodes
              for (var i = 0; i < idChildNode.length; i++) {
                if (idChildNode[i].nodeName === 'P') {
                  _desc = idChildNode[i].innerHTML
                }
              }
            }
          }
        }

        // 如果问题不为空
        if (_desc !== '') {
          if (_desc.length > 50) {  // 如果问题字符长度大于50个
            desc = _desc.replace(/(^\s*)|(\s*$)/g, '').substr(0, 49) + '...'   // 前50个字符
          } else {
            desc = _desc.replace(/(^\s*)|(\s*$)/g, '')
          }
        } else {
          desc = '你可以点击查看详情...'
        }
        // 如果描述为空
        if (desc === '') {
          desc = '你可以点击查看详情...'
        }
      }

      // 问题库
      if (stype === '5') {
        console.log('问题库')
        // 获取问题
        let que = ''
        let nodeName = ''
        if (document.getElementById(id)) {
          nodeName = document.getElementById(id).nodeName  // 节点类型
          if (nodeName === 'P') {  // 标题
            que = document.getElementById(id).innerHTML
          }
          if (nodeName === 'TD') {
            let td = document.getElementById(id)
            // let qCont = td.firstElementChild
            let qCont = td.lastElementChild
            let queEle = qCont.firstElementChild
            let queText = queEle.innerText
            que = queText
          }
        }

        // 如果问题不为空
        if (que !== '') {
          if (que.length > 50) {  // 如果问题字符长度大于50个
            desc = que.replace(/(^\s*)|(\s*$)/g, '').substr(0, 49) + '...'   // 前50个字符
          } else {
            desc = que.replace(/(^\s*)|(\s*$)/g, '')
          }
        } else {
          desc = '你可以点击查看详情...'
        }

        // 如果描述为空
        if (desc === '') {
          desc = '你可以点击查看详情...'
        }
      }
      console.log(desc)
      return desc
    },

    /**
     * 分享公告详情
     * @param  { String } stype     板块类型
     * @param  { String } id        定位id
     * @param  { String } fulltitle 公告标题
     * @param  { String } desc      分享描述
     */
    shareNotice (stype, id, fulltitle, desc) {
      let title = fulltitle
      let shareId = id.toString()
      let shareImgLink = window.location.origin + '/static/images/wx-share-logo.jpg'
      let href = window.location.href
      let shareLink = ''

      // 修改分享url中的uid 和 ruid查询参数
      href = this.changeUrlArg(href, 'uid', this.uid)
      href = this.changeUrlArg(href, 'ruid', this.params.uidUrl)
      //修改定位
      if (id != 'undefined') {
        console.log('tcode:'+id)
        // href = this.changeUrlArg(href, 'tcode', id)
      }
      shareLink = href

      this.wxSDKConfig(title, shareImgLink, shareLink, desc);
    },

    // get分享描述 - search + result
    getResultShareDesc () {
      console.log('分享描述')
      let sharetitle = '你的朋友' + this.shareUsername + '通过IBDATA给你分享了一份他的独家数据！'
      return sharetitle
    },

    // get分享标题 - search + result
    getResultShareTitle () {
      let desc = ''
      if (this.keywords.length > 0) {
        if (!this.diysharedesc) {
          let stype = this.stype
          if (stype === 1) {
            this.stypename = 'A股'
          } else if (stype === 2) {
            this.stypename = '新三板'
          } else if (stype === 3) {
            this.stypename = '债券'
          } else if (stype === 4) {
            this.stypename = '知识库'
          } else if (stype === 5) {
            this.stypename = '问题库'
          } else if (stype === 6) {
            this.stypename = '港股'
          } else if (stype === 7) {
            this.stypename = '法院公告'
          } else if (stype === 8) {
            this.stypename = '裁判文书'
          } else if (stype === 9) {
            this.stypename = '政府公告'
          } else {
            this.stypename = stype
          }
          desc = this.stypename + '-' + this.keywords
        } else {
          desc = this.diysharedesc
        }
      } else {
        if (this.diysharedesc) {
          desc = this.diysharedesc;
        } else {
          desc = document.title
        }
      }
      return desc
    },

    /*
     * 分享搜索结果
     * @params {String} - 分享标题
     * @params {String} - 分享描述
     * */
    shareResult (fulltitle, desc) {
      let title = fulltitle
      let shareImgLink = window.location.origin + '/static/images/wx-share-logo.jpg'
      let href = window.location.href
      let shareLink = ''

      href = this.changeUrlArg(href, 'uid', this.uid)
      href = this.changeUrlArg(href, 'ruid', this.params.uidUrl)
      shareLink = href

      this.wxSDKConfig(title, shareImgLink, shareLink, desc);
    },

    /**
     * 分享搜索页
     * @params {String} - 分享标题
     * @params {String} - 分享描述
     */
    shareSearch(fulltitle, desc) {
      let title = fulltitle
      let shareImgLink = window.location.origin + '/static/images/wx-share-logo.jpg'
      let href = window.location.href
      let shareLink = ''

      if (href.indexOf('uid')>0 && href.indexOf('ruid')>0 && href.indexOf('sid')>0) {
        href = this.changeUrlArg(href, 'uid', this.uid)
        href = this.changeUrlArg(href, 'ruid', this.params.uidUrl)
        if (window.location.href.indexOf('search?ai=')>0) {
          console.log('go  result')
          shareLink = href.split('search?')[0] + 'result?' + href.split('search?')[1]
        }
        if (window.location.href.indexOf('search=true')>0) {
          shareLink = href
        }
        console.log('no sharelink')
        console.log(shareLink)
      } else {
        let ts = this.getTimeStamp();
        this.params.ts = ts;
        href = href + '&uid=' + this.uid + '&ruid=0' + '&plat=mobile' + '&ts=' + ts
        if (window.location.href.indexOf('search=true')>0) {
          shareLink = this.getShareLink(href, 'search');
        }
        if (window.location.href.indexOf('search?ai=')>0) {
          console.log('go  result')
          shareLink = this.getShareLink(href, 'result');
        }
      }
      console.log('>>> shareLink')
      console.log(shareLink);

      this.wxSDKConfig(title, shareImgLink, shareLink, desc);
    },

    shareStatus (sid, status) {
      if (!sid) {
        return false
      }

      let query = {}
      query.sid = sid
      query.status = status
      console.log('shareStatus')
      console.log(query)
      if (sid != 'undefined') {
        $.ajax({
          url: apiUrl('/V1.0.0/user/updshare'),
          method: 'post',
          dataType: 'json',
          data: JSON.stringify(query),
          async: false
        }).done((response) => {
          if (response.status === 0) {
            console.log(response);
            console.log('share--status')
          } else {
            console.log(response.description)
          }
        }).fail((response) => {
          console.log(response)
        })
      }
    },

    /**
     * 微信分享sdk
     * @param  {String} title  标题
     * @param  {String} imgUrl 图标链接
     * @param  {String} link   分享链接
     * @param  {String} desc   描述
     * @return {String}
     */
    wxSDKConfig(title, imgUrl, link, desc) {
      let shareTitle = title || ''
      let shareImgLink = imgUrl || ''
      let shareLink = link || ''
      let shareDesc = desc || ''

      console.log('wxSDKConfig')
      console.log(shareTitle)
      console.log(shareImgLink)
      console.log(shareLink)
      console.log(shareDesc)

      let that = this
      // 通过ready接口处理config成功验证
      wx.ready(function () {
        // 需要检测的JS接口列表
        wx.checkJsApi({
          jsApiList: [
            'onMenuShareAppMessage',
            'onMenuShareTimeline'
          ],
          success: function (res) {
            // 以键值对的形式返回，可用的api值true，不可用为false
            // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
            console.log(JSON.stringify(res))
          }
        })

        // 注册获取“发送给朋友”状态事件
        wx.onMenuShareAppMessage({
          title: shareTitle,
          desc: shareDesc,
          link: shareLink,
          imgUrl: shareImgLink,
          // 监听Menu中的按钮点击时触发的方法，该方法仅支持Menu中的相关接口
          // 不要尝试在trigger中使用ajax异步请求修改本次分享的内容，因为客户端分享操作是一个同步操作，这时候使用ajax的回包会还没有返回
          trigger: function (res) {
            console.log('用户点击发送给朋友')
          },
          success: function () {
            console.log('分享给朋友——成功！')
            console.log(title)
            console.log(desc)
            console.log(shareImgLink)
            console.log(shareLink)
            that.shareStatus(that.params.sid, 1)
          },
          cancel: function () {
            console.log('分享给朋友——取消！')
          },
          fail: function (res) {
            console.log(JSON.stringify(res))
            that.shareStatus(that.params.sid, 3)
          }
        })

        // 注册获取“分享到朋友圈”状态事件
        wx.onMenuShareTimeline({
          title: shareTitle,
          link: shareLink,
          imgUrl: shareImgLink,
          trigger: function (res) {
            console.log('分享到朋友圈')
          },
          success: function () {
            console.log('分享到朋友圈——成功！')
            console.log(shareImgLink)
            that.shareStatus(that.params.sid, 1)
          },
          cancel: function () {
            console.log('分享到朋友圈——取消！')
          },
          fail: function (res) {
            console.log(JSON.stringify(res))
            that.shareStatus(that.params.sid, 3)
          }
        })
      })

      // 通过error接口处理失败config验证
      wx.error(function(res) {
        console.log(JSON.stringify(res))
      })
    },

    // =====================================================================其他
    /**
     * 修改标题
     */
    changeMetaTitle (title) {
      document.title = title
    },

    /**
     * return 文章主体内所有id
     */
    getAllId (allId) {
      return allId
    },

    /**
     * 元素是否在可视区域内
     */
    innerWindow (id) {
      let el = document.getElementById(id)
      if (el === null) {
        return false
      }

      let rect = el.getBoundingClientRect()
      let boxTop = 0
      let boxHeight = window.innerHeight
      let flag = (rect.top >= boxTop && (rect.bottom - boxTop) <= boxHeight)
        || (rect.top >= boxTop && (rect.top - boxTop) < boxHeight && (rect.bottom - boxTop) > boxHeight)
        || (rect.top <= boxTop && (rect.bottom - boxTop) >= boxHeight)

      return flag
    },

    /**
     * 返回可视区域内符合条件的id
     * @param  {Arr} arr id数组
     * @return {String}  在可视区域内的第一个id字符串 or 空字符串
     */
    getInnerWindowId (arr) {
      let len = arr.length
      let aimId = ''

      for (var i = 0; i < len; ++i) {
        if (this.innerWindow(arr[i])) {
          aimId = arr[i]
          break
        }
      }
      //遍历完，若没有一个在可视区域，则返回空字符串
      return aimId
    },

    /**
     * 融资信息页分享
     * @param  {[type]} fulltitle [description]
     * @param  {[type]} desc      [description]
     */
    shareFinanceDetail (fulltitle, desc) {
      let title = fulltitle;
      let shareImgLink = window.location.origin + '/static/images/wx-share-logo.jpg';
      let href = window.location.href;
      let shareLink = '';

      // 修改分享url中的uid 和 ruid查询参数
      href = this.changeUrlArg(href, 'uid', this.uid);
      href = this.changeUrlArg(href, 'ruid', this.params.uidUrl);
      shareLink = href;
      // console.log(title);
      // console.log(shareImgLink);
      // console.log(shareLink);
      // console.log(desc);
      this.wxSDKConfig(title, shareImgLink, shareLink, desc);
    },

    /**
     * 大黄押 - 初步尽调 分享
     * @param  { String } stype     板块类型
     * @param  { String } id        定位id
     * @param  { String } fulltitle 公告标题
     * @param  { String } desc      分享描述
     */
    shareDhyCbjd (fulltitle, desc) {

      let title, shareImgLink, shareLink, href;

      title = fulltitle;
      shareImgLink = window.location.origin + '/static/images/wx-share-logo.jpg';
      // 修改分享url中的uid 和 ruid查询参数
      href = window.location.href;
      href = this.changeUrlArg(href, 'uid', this.uid)
      href = this.changeUrlArg(href, 'ruid', this.params.uidUrl)
      shareLink = href

      this.wxSDKConfig(title, shareImgLink, shareLink, desc);
    },

    /**
     * 公司分享
     *
     * @param { String } title  分享标题
     * @param { String } desc   分享描述
     */
    shareCompany: function(title, desc) {
      console.log('-------------------------');
      console.log(title);
      console.log(desc);
      console.log(this.queryParam);
      console.log(this.currentuser);
      console.log('-------------------------');

      let shareImgLink, shareLink, href;
      shareImgLink = window.location.origin + '/static/images/wx-share-logo.jpg';
      href = window.location.href;
      href = this.changeUrlArg(href, 'uid', this.currentuser.uid)
      href = this.changeUrlArg(href, 'ruid', this.queryParam.uid)
      shareLink = href;

      this.wxSDKConfig(title, shareImgLink, shareLink, desc);
    },


  }
}



/** WEBPACK FOOTER **
 ** ./src/common/wxshareMix.js
 **/